import { now, createDate, dateDiff } from '@/lib/dateUtils.js'
import _ from 'lodash'

const _parseHierarchicalObjects = function (obj, path = []) {
  if (!obj) return []
  const keys = Object.keys(obj)
  return keys
    .map(key => {
      if (!obj[key].children) {
        const base = {}
        Object.keys(obj[key]).map(k => {
          base[k] = obj[key][k]
        })
        base.path = [...path, {
          id: obj[key].id,
          name: obj[key].name
        }]
        return [base]
      }
      return _parseHierarchicalObjects(obj[key].children, [...path, {
        id: obj[key].id,
        name: obj[key].name
      }])
    })
    .reduce((arr, it) => {
      return [...arr, ...it]
    }, [])
}

// id, childrenを持つ階層構造オブジェクトに対し、基底オブジェクトへのパスを解析します。
// ex.)
// [{                                                  [{
//   id: 1,                                                "id": 1,
//   name: 'ITエンジニア関連職種',                            "name": "要件定義"
//   children: [{                                          "path": [
//     id: 1,                                 ->              { "id": 1, "name": "ITエンジニア関連職種" },
//     name: '経験業務',                                       { "id": 1, "name": "経験業務" },
//     children: [{                                           { "id": 1, "name": "システム開発（ オープン・ Web系）" },
//       id: 1,                                               { "id": 1, "name": "要件定義" }
//       name: 'システム開発（ オープン・ Web系）',             ]
//       children: [{                                   }]
//           id: 1,
//           name: '要件定義'
//         }]
//     }]
//   }]
// }]
const parseHierarchicalObjects = function (obj) {
  return _parseHierarchicalObjects(obj)
}

const age = (birthdateString) => {
  return dateDiff(now(), createDate(birthdateString), 'years') ?? ''
}

const numberValue = (value, suffix = '', unregisteredValue = '', prefix = '', isUnregisteredLabel = true) => {
  // 第1引数（label）が真偽判定で偽となる値（null or ''  or false）の場合は
  // 第3引数（unregisterdValue）+ '未登録' を返却する
  // それ以外の場合は 第4引数(prefix) + 第1引数（label）+ 第2引数（suffix）を返却する
  // 第5引数はlabelが無効の時に未登録を付与するかどうか
  return _.isNumber(value) ? prefix + value + suffix : isUnregisteredLabel ? unregisteredValue + '未登録' : unregisteredValue
}

export {
  parseHierarchicalObjects,
  age,
  numberValue
}
